'use client'

import React from 'react'

// SP（スマホ/タブレット）判定のしきい値。PC ブレークポイント（1024px）未満を SP とみなす。
// SMS2段階認証は SP のみ利用可能なため、この判定で導線の出し分けを行う。
const SP_MAX_WIDTH = 1023

/**
 * 現在のビューポートが SP（PC 未満 = 1024px 未満）かどうかを返す。
 *
 * SSR・初回レンダリングではレイアウト不整合（hydration mismatch）を避けるため false を返し、
 * マウント後に matchMedia で実値へ更新する。
 */
export const useIsSp = (): boolean => {
  const [isSp, setIsSp] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return

    const mql = window.matchMedia(`(max-width: ${SP_MAX_WIDTH}px)`)
    const update = () => setIsSp(mql.matches)

    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  return isSp
}
